import React from "react";
import Markdown from "~/components/Markdown";
import Collapsable from "~/components/Collapsable";
import { Badge, Link, Picture, Text } from "~/components-shared";
import { CollapsableTypeEnum } from "~/types/enums";
import styled from "styled-components";
import FootprintActions from "~/components/FootprintActions";
const Underline = styled.span`
  text-decoration: underline;
`;
const TopicFootprintContentLinear = _ref => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref;
  const {
    actions,
    data: {
      issueKey,
      issueStatusName,
      issueTitle,
      issueLabels,
      issueDescription,
      issueUrl,
      assigneeName,
      assigneeAvatar,
      assigneeUrl,
      comment
    }
  } = footprint;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(FootprintActions, {
    actions: actions
  }), " a Linear issue", " ", /*#__PURE__*/React.createElement(Link, {
    href: issueUrl,
    underline: true
  }, issueKey), " ", assigneeName && /*#__PURE__*/React.createElement(Text, null, " ", "assigned to", " ", assigneeAvatar && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Picture, {
    src: assigneeAvatar,
    width: "1.4rem",
    height: "1.4rem",
    display: "inline-block",
    border: "circled",
    s: {
      mb: -1
    }
  }), " "), /*#__PURE__*/React.createElement(Link, {
    href: assigneeUrl,
    underline: true
  }, assigneeName), " "), !!issueLabels?.length && /*#__PURE__*/React.createElement(Text, null, " ", "labelled with ", /*#__PURE__*/React.createElement(Underline, null, issueLabels.join(", ")))), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4.5,
    lineHeight: 6.5,
    display: "block",
    s: {
      my: 1
    }
  }, issueTitle, /*#__PURE__*/React.createElement(Badge, {
    color: "grey",
    display: "inline",
    s: {
      py: 0.5,
      mx: 2
    }
  }, issueStatusName)), issueDescription && /*#__PURE__*/React.createElement(Collapsable, {
    maxHeight: 0,
    type: CollapsableTypeEnum.BUTTON,
    s: {
      mb: 3
    },
    collapsedText: "View task description",
    expandedText: "Hide task description"
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: issueDescription,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  }))), !hideMessage && comment && /*#__PURE__*/React.createElement(Collapsable, {
    s: {
      mb: 1
    }
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: comment,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  })));
};
export default TopicFootprintContentLinear;